import { BrowserRouter } from 'react-router-dom';
import { useEffect, useState, useLayoutEffect } from 'react';
import { ThemeProvider, useMediaQuery } from '@mui/material';
import { Scrollbars } from 'react-custom-scrollbars-2';

import './App.css';
import Routing from './navigation/Route';
import Header from './components/header/Header';
import { DefaultTheme } from './config/Theme';
import GlobalSnackbar from './components/global_snackbar/GlobalSnackbar';

import { useDispatch, useSelector } from 'react-redux';

function App() {
  const mobileView = useMediaQuery('(max-width:600px)');
  const [snackState, setSnackState] = useState({
    open: false,
    message: '',
  });
  const [height, setHeight] = useState('100vh');
  const [viewport, setViewport] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  const dispatch = useDispatch();
  const { notification } = useSelector((state) => state.commonState);

  useLayoutEffect(() => {
    const handleResize = () => {
      if (viewport.width !== window.innerWidth) window.location.reload(false);
    };

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    setViewport({
      width: window.innerWidth,
      height: window.innerHeight,
    });
  }, [window.innerWidth, window.innerHeight]);

  useEffect(() => {
    if (notification) {
      setSnackState({
        open: true,
        message: notification.msg || 'Something went wrong',
        theme: notification.theme || 'warning',
      });
      setTimeout(() => {
        dispatch({ type: 'RESET_NOTIFICATION' });
        setSnackState({ ...snackState, open: false, message: '' });
      }, 5000);
    }
  }, [notification]);

  useEffect(() => {
    if (!mobileView) {
      document.getElementsByTagName('body')[0].style.overflow = 'hidden';
    } else {
      document.getElementsByTagName('body')[0].style.overflow = 'auto';
    }
  }, [mobileView]);

  return (
    <div>
      <ThemeProvider theme={DefaultTheme}>
        <Scrollbars style={{ minHeight: height }}>
          <BrowserRouter>
            <Header />
            <Routing mobileView={mobileView} setHeight={setHeight} />
          </BrowserRouter>
        </Scrollbars>
      </ThemeProvider>
      <GlobalSnackbar
        message={snackState.message}
        theme={snackState.theme}
        open={snackState.open}
      />
    </div>
  );
}

export default App;
